<template>
  <div style="margin-bottom: 10px">
    <a-form
      class="simiot-nested-search-form"
      :form="form"
      @submit="handleSearch"
    >
      <a-row :gutter="24">
        <a-col :xl="8" :xxl="6">
          <a-form-item label="客户名称">
            <a-input
              v-decorator="['agent_name', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="请输入客户名称"
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="账单类型">
            <a-select
              v-decorator="['bill_type']"
              allow-clear
              placeholder="请选择账单类型"
            >
              <a-select-option
                v-for="item in billTypeOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="账单时间">
            <a-range-picker v-decorator="['agent_bill_time']" />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { formatRangeBeginDate, formatRangeEndDate } from '@/utils/time'

// 账单类型顺序：卡 → eSIM → Profile → 模组 → CPE，其余类型附后
const ADDITIONAL_BILL_TYPE_OPTIONS = [
  { value: 0, name: '卡采购账单' },
  { value: 5, name: 'eSIM采购账单' },
  { value: 6, name: 'Profile采购账单' },
  { value: 3, name: '模组采购账单' },
  { value: 4, name: 'CPE采购账单' },
  { value: 2, name: '激活账单' }
]

const STORED_BILL_TYPE_OPTIONS = [
  { value: 1, name: '续期账单' }
]

export default {
  name: 'SearchSaleAgentMonthlyPerformance',
  props: {
    // additional | stored
    statisticType: {
      type: String,
      default: 'additional'
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'sale_agent_monthly_performance_search' })
    }
  },
  computed: {
    billTypeOptions() {
      return this.statisticType === 'stored'
        ? STORED_BILL_TYPE_OPTIONS
        : ADDITIONAL_BILL_TYPE_OPTIONS
    }
  },
  methods: {
    buildQuery(fieldsValue) {
      return {
        agent_name: fieldsValue.agent_name,
        bill_type: fieldsValue.bill_type,
        agent_bill_time_begin: formatRangeBeginDate(fieldsValue.agent_bill_time),
        agent_bill_time_end: formatRangeEndDate(fieldsValue.agent_bill_time)
      }
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.buildQuery(this.form.getFieldsValue()))
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
